exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes diminish{0%{transform:scale(1.05)}to{transform:scale(1)}}.node-item{padding-right:10px;max-width:300px;cursor:move;position:relative;z-index:4;padding-left:10px;font-size:11.9px;border-radius:3px;background-repeat:repeat-x;vertical-align:middle;display:inline-block;overflow:hidden;margin-bottom:0;background-color:#fff;box-shadow:0 0 8px 0 rgba(150,162,180,.33);border-radius:5px;border:1px solid #eef3f8;animation-name:diminish;animation-fill-mode:forwards;animation-duration:.5s;animation-timing-function:inherit}.node-item,.node-item .node-con{height:38px;line-height:38px}.node-item .node-con .type-icon{display:inline-block;width:28px;height:28px;text-align:center;font-size:16px;border-radius:3px;line-height:26px;margin-right:12px;color:#fff;background-color:#009788}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-48cd90b4","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./packages/yz-flow/src/flowNode.vue
// module id = 15
// module chunks = 0